<template>
  <div class="pepper-scene">
    <div class="pepper-scene__bg-dot">
      <!-- logotype -->
      <div class="pepper-scene__logotype">
        <SvgSymbol use="#pepper-logo"/>
      </div>
      <!-- scenario -->
      <div class="pepper-scene__scenario">
        <div class="pepper-scene__background"><SvgSymbol class="pepper-scene__background-wave" use="#pepper-scene-wave-fuchsia"/></div>
        <div class="pepper-scene__portrait"></div>
        <div class="pepper-scene__foreground"><SvgSymbol class="pepper-scene__foreground-wave" use="#pepper-scene-wave-blue"/></div>
      </div>
    </div>

    <div class="pepper-scene__scroll" title="往下捲動" @click="onScrollClick">
      <div class="pepper-scene__scroll-label">SCROLL</div>
      <div class="pepper-scene__scroll-dot"></div>
      <div class="pepper-scene__scroll-dot"></div>
      <div class="pepper-scene__scroll-dot"></div>
      <div class="pepper-scene__scroll-dot"></div>
      <div class="pepper-scene__scroll-dot"></div>
      <div class="pepper-scene__scroll-arrow"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PepperScene',
  methods: {
    onScrollClick (event) {
      this.$ga('newmedia.send', {
        'hitType': 'event',
        'eventCategory': 'Click',
        'eventAction': 'Click',
        'eventLabel': `Scroll-to-topics`
      })
      this.$scrollTo('#topic', 500, { offset: -30 })
    }
  }
}
</script>

<style lang="scss">
.pepper-scene {
  @include use-layer(&);
  position: relative;
  width: 100%;
  min-height: 0;
  top: 1px;
  background:#6a80d3;
  @include rwd($RWD_DESKTOP_WIDE) {
    // height: 100vh;
    // overflow: hidden;
  }

  &__bg-dot {
    margin-top: -1px;
    background: url(~@/assets/background-dot.png) repeat top left;
    border-top: 1px solid white;
  }

  &__logotype {
    z-index: 3;
    display: block;
    position: relative;
    width: 77%;
    margin: 55px auto 17px auto;
    @include use-fixed-ratio(247, 175);
    @include rwd($RWD_TABLET_SMALL) {
      width: 77.5%;
      margin: 120px auto 34px auto;
    }
    @include rwd($RWD_TABLET) {
      width: 61.31%;
      margin: 84px auto 23px auto;
    }
    @include rwd($RWD_DESKTOP) {
      position: absolute;
      top: 109px;
      left: 4.8%;
      width: 41.35%;
      margin: 0;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      left: 14.58%;
      width: 32.65%;
    }

    .svg-symbol {
      position: absolute;
      top: 0;
      left: 0;
    }
  }

  &__scenario {
    z-index: 1;
    position: relative;
    top: 1px;
    overflow: hidden;
    @include rwd($RWD_DESKTOP) {
      padding: 158px 0 50px 0;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      padding: 110px 0 50px 0;
    }
  }

  &__background,
  &__foreground {
    position: absolute;
    width: 100%;
    @include use-fixed-ratio(320, 76);
    @include rwd($RWD_DESKTOP) {
      width: 108%;
    }

    .svg-symbol {
      position: absolute;
      top: 0;
      left: 0;
    }
  }

  &__background {
    bottom: 25px;
    @include rwd($RWD_DESKTOP) {
      bottom: 55px;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      bottom: -50px;
    }
  }

  &__foreground {
    bottom: 0;
    @include rwd($RWD_DESKTOP_WIDE) {
      bottom: -105px;
    }
  }

  &__portrait {
    position: relative;
    width: 75%;
    margin: 0 auto;
    background: url(~@/assets/chuchupepper-pic.png) no-repeat center center / contain;
    @include use-fixed-ratio(235, 279);
    @include rwd($RWD_TABLET_SMALL) {
      width: 59.07%;
    }
    @include rwd($RWD_DESKTOP) {
      width: 46.77%;
      left: 23%;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      width: 43.61%;
      left: 20%;
    }
  }

  &__scroll {
    z-index: 2;
    position: absolute;
    left: 50%;
    bottom: 70px;
    width: 60px;
    margin-left: -30px;
    color: white;
    text-align: center;
    background: transparent;
    user-select: none;
    cursor: pointer;
    @include rwd($RWD_TABLET_SMALL) {}
    @include rwd($RWD_TABLET) {}
    @include rwd($RWD_DESKTOP) {}
    @include rwd($RWD_DESKTOP_WIDE) {}
    @include rwd($RWD_DESKTOP_1660) {
      position: fixed;
      bottom: 60px;
      margin-left: -(30px + 35px);
    }

    &:active {
      transform: translateY(2px);
    }

    &-label {
      font-size: 0.875em;
    }

    &-dot {
      width: 2px;
      height: 2px;
      margin: 4px auto 0 auto;
      background: white;
      border-radius: 50%;

      & + & + & + & {
        display: none;

        @include rwd($RWD_IPHONE_678) {
          display: block;
        }
      }
    }

    &-arrow {
      width: 0;
      height: 0;
      margin: 8px auto 0 auto;
      border: 6px solid transparent;
      border-bottom: none;
      border-top: 7px solid white;
    }
  }
}

.mobile {
  .pepper-scene {
    min-height: 100vh;
  }
}

.narrow-desktop { // Inject by App.vue when viewport size 960&up + 768&down
  .pepper-scene {
    &__scenario {
      margin-top: -158px;
    }

    &__logotype {
      transform-origin: top center;
      transform: translate(10%, -50px) scale(0.7);
    }

    &__portrait {
      transform-origin: bottom center;
      transform: translate(-10%, -70px) scale(0.75);
    }

    &__scroll {
      position: fixed;
      bottom: 30px;
      margin-left: -(30px + 35px);
    }
  }
}

.over-screenline { // Inject by App.vue when viewport size 960&up + 768&down
  .pepper-scene {
    &__scroll {
      display: none;
    }
  }
}
</style>
